export const data = [
	{
		to: '/sobre',
		text: 'Sobre',
	},
	{
		to: '/contato',
		text: 'Contato',
	},
];